/**
 * 后台字体（PRD §8.4「字体」；platform REQ-8.4-005）：与用户端相同，韩语 Pretendard、日语 Noto Sans JP、中文 Noto Sans SC、英语 Inter；
 * 数字统一取 Inter（等宽）。按当前语言动态加载，未就绪时先用系统字体。
 */
import type { Lang } from '@nexora/i18n';

const LANG_FONTS: Readonly<Record<Lang, (() => Promise<unknown>) | null>> = {
  ko: () => import('pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css'),
  ja: () => import('@fontsource-variable/noto-sans-jp'),
  zh: () => import('@fontsource-variable/noto-sans-sc'),
  en: null,
};

const loaded = new Map<string, Promise<unknown>>();

function once(id: string, load: () => Promise<unknown>): Promise<unknown> {
  let task = loaded.get(id);
  if (!task) {
    task = load().catch(() => undefined);
    loaded.set(id, task);
  }
  return task;
}

export async function loadAdminFonts(lang: Lang): Promise<void> {
  const tasks = [once('inter', () => import('@fontsource-variable/inter'))];
  const langFont = LANG_FONTS[lang];
  if (langFont) tasks.push(once(lang, langFont));
  await Promise.all(tasks);
}
